import { onNativeEvent } from "../platform/android/nativeEventBus";
import { NATIVE_EVENTS } from "../platform/android/nativeMethods";
import { sendBranchTrafficData } from "../api/services/branchTrafficData.service";
import useAppStore from "../store/useAppStore";
import { parseNativeResponse } from "./ParseNativeResponse";

let isInitialized = false;
let pendingBranchData = null;

export const sendSavedBranchData = async () => {
  const data = pendingBranchData;
  if (!data) return;

  pendingBranchData = null;

  try {
    await sendBranchTrafficData(data);
  } catch (err) {
    console.warn("Branch traffic data send failed", err);
  }
};

export const handleBranchTrafficData = async (jsonPayload) => {
  try {
    const { userToken } = useAppStore.getState();
    let finalPayload = jsonPayload;
    if (jsonPayload && !jsonPayload.properties) {
      finalPayload = {
        properties: {
          traffic_source: jsonPayload.traffic_source || "Organic",
          referral_code: jsonPayload.referral_code || "Organic",
          campaign: jsonPayload.campaign || jsonPayload["~campaign"] || "Organic",
          deeplink_data: JSON.stringify(jsonPayload),
          datasource: "branch",
        },
      };
    }

    if (userToken) {
      // User is logged in: Send attribution data
      pendingBranchData = null;
      await sendBranchTrafficData(finalPayload);
    } else {
      pendingBranchData = finalPayload;
    }
  } catch (err) {
    console.error("Failed to handle branch traffic data", err);
  }
};

export const initBranchTrafficManager = () => {
  if (isInitialized) return;
  isInitialized = true;

  onNativeEvent(NATIVE_EVENTS.BRANCH_TRAFFIC_DATA, async (payload) => {
    const jsonPayload = parseNativeResponse(payload);
    await handleBranchTrafficData(jsonPayload);
  });
};
